export enum LOCAL_STORAGE_KEYS {
  LOGIN_REDIRECT = 'LOGIN_REDIRECT',
}
